import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hire-ios-apps-dev',
  templateUrl: './hire-ios-apps-dev.component.html',
  styleUrls: ['./hire-ios-apps-dev.component.css']
})
export class HireIosAppsDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/hire-ios-apps-dev/hire-ios-apps-dev.component.ts